import React from 'react';
import { Grid, Typography } from '@mui/material';
import { CustomButton, CustomTextField, InputProps } from '../../../.././custom/components';
import styles from '../../../../custom/style.module.css';
import docStyles from '../docs.module.css';
import { Stack } from '@mui/system';

const HouseDoc = (props) => {
  const { formFields, handleChangeForm, docId, submit } = props;

  const renderTextField = (label, name, placeholder, value) => (
    <Stack direction='row' justifyContent='space-between' alignItems='center' useFlexGap flexWrap='wrap'>
      <Typography variant='caption' component='label' htmlFor={name}>{label}</Typography>
      <div className={docStyles.addTextField}>
        <CustomTextField
          {...InputProps}
          id={name}
          fullWidth
          placeholder={placeholder}
          type='text'
          onChange={(e) => handleChangeForm(e, name)}
          // onBlur={name == 'awb_no' ? checkAwb : () => { }}
          name={name}
          value={value}
        />
      </div>
    </Stack>
  );


  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className={styles.w100}>
        {renderTextField('House Airwaybill Number', 'house_awb_no', 'House Airwaybill Number', formFields.house_awb_no)}
      </Grid>
      <Grid item xs={12} sm={6} md={12} lg={12} xl={12} className={styles.w100}>
        {renderTextField('Pieces', 'pcs', 'Pieces', formFields.pcs)}
      </Grid>
      <Grid item xs={12} sm={6} md={12} lg={12} xl={12} className={styles.w100}>
        {renderTextField('Weight', 'wgt', 'Weight', formFields.wgt)}
      </Grid>
      <Grid item xs={12} sm={6} md={12} lg={12} xl={12} className={styles.w100}>
        {renderTextField('Origin', 'org', 'Origin', formFields.org)}
      </Grid>
      <Grid item xs={12} sm={6} md={12} lg={12} xl={12} className={styles.w100}>
        {renderTextField('Destination', 'dest', 'Destination', formFields.dest)}
      </Grid>
      <Grid item xs={12} className={`${docStyles.docBtn} ${docStyles.docBtnOnly}`}>
        <CustomButton variant='contained' disabled={!docId} onClick={submit}> Update </CustomButton>
      </Grid>
    </Grid>
  );
};

export default HouseDoc;
